module.exports = __webpack_public_path__ + "img/oct_24.3d22bcc1.png";